"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CreateGiftContact = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RecipientDetailsCreate = _interopRequireDefault(require("./containers/RecipientDetails/RecipientDetailsCreate"));

var _useRecipientCreate = require("./hooks/useRecipientCreate");

var _user = require("./shapes/user.shape");

var CreateGiftContact = function CreateGiftContact(_ref) {
  var onCreate = _ref.onCreate,
      onBulkCreate = _ref.onBulkCreate,
      onClose = _ref.onClose,
      hasInternational = _ref.hasInternational,
      initialRecipientData = _ref.initialRecipientData,
      forceCreateRecipientFlow = _ref.forceCreateRecipientFlow,
      sidebarMode = _ref.sidebarMode,
      user = _ref.user,
      campaignId = _ref.campaignId;
  (0, _useRecipientCreate.useRecipientCreate)(onCreate);
  return /*#__PURE__*/_react.default.createElement(_RecipientDetailsCreate.default, {
    onBulkCreate: onBulkCreate,
    onClose: onClose,
    hasInternational: hasInternational,
    initialRecipientData: initialRecipientData,
    forceCreateRecipientFlow: forceCreateRecipientFlow,
    sidebarMode: sidebarMode,
    user: user,
    campaignId: campaignId
  });
};

exports.CreateGiftContact = CreateGiftContact;
CreateGiftContact.propTypes = {
  onCreate: _propTypes.default.func.isRequired,
  onBulkCreate: _propTypes.default.func,
  onClose: _propTypes.default.func.isRequired,
  initialRecipientData: _propTypes.default.shape({
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    employment: _propTypes.default.string,
    email: _propTypes.default.string
  }),
  hasInternational: _propTypes.default.bool,
  forceCreateRecipientFlow: _propTypes.default.bool,
  sidebarMode: _propTypes.default.bool,
  user: _user.User.isRequired,
  campaignId: _propTypes.default.number
};
CreateGiftContact.defaultProps = {
  hasInternational: false,
  forceCreateRecipientFlow: false,
  sidebarMode: true,
  initialRecipientData: {
    firstName: '',
    lastName: '',
    employment: '',
    email: ''
  },
  onBulkCreate: null,
  campaignId: undefined
};
var _default = CreateGiftContact;
exports.default = _default;